<div class="m-3">
  <div class="grid md:grid-cols-1 md:gap-2">
    <div *ngIf="trucks$ | async as trucks">
      <div class="flex flex-row justify-between">
        <div class="text-lg font-bold mb-1">Trucks</div>
        <button mat-stroked-button color="primary" (click)="addTruckPrompt()">Add Truck</button>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-1 mt-1" *ngIf="trucks.length; else noTrucks">
        <div *ngFor="let truck of trucks; trackBy: 'id' | trackByKey">
          <div class="bg-white shadow rounded p-2 flex flex-col">
            <div class="font-semibold flex justify-between">
              <span>{{ truck.truckName }}</span>
              <span [ngClass]="truck.truckStatus !== 'operational' ? 'text-red-500' : ''">{{
                truck.truckStatus | operational
              }}</span>
            </div>
            <!--<div>{{ truck.assignedTo | dashIfNothing }} <span *ngIf="truck.assignedTo">({{ truck.assignedToPhone }}
              )</span></div>-->
            <ng-container *ngIf="truck.inUse; else lastUsed">
              Currently in used by {{ truck.lastUsed.userName }} on load {{ truck.lastUsed.uniqueOrderId }}
            </ng-container>
            <ng-template #lastUsed>
              <div *ngIf="truck.lastUsed">
                Last used by {{ truck.lastUsed.userName }} on load {{ truck.lastUsed.uniqueOrderId }}
              </div>
            </ng-template>
            <div class="mt-1 hidden md:contents">
              <img
                class="w-full"
                *ngIf="truck.lastUsed"
                [src]="imageUrl(truck.lastUsed.lastLocation[1], truck.lastUsed.lastLocation[0])"
              />
            </div>
            <div class="mt-1 md:hidden">
              <img
                class="w-full"
                *ngIf="truck.lastUsed"
                [src]="imageUrlMobile(truck.lastUsed.lastLocation[1], truck.lastUsed.lastLocation[0])"
              />
            </div>
            <div class="text-sm text-gray-500 mt-1">
              <ng-container *ngIf="truck.truckOwner">{{ truck.truckOwner }}</ng-container>
              <ng-container *ngIf="truck.truckOwner && truck.truckLessee"> - </ng-container>
              <ng-container *ngIf="truck.truckLessee">{{ truck.truckLessee }}</ng-container>
            </div>
            <ng-container *ngIf="truck.maintenanceEvents?.length">
              <mat-accordion displayMode="flat">
                <mat-expansion-panel class="rounded-none mat-elevation-z0">
                  <mat-expansion-panel-header style="padding: 0 !important"
                    >{{ truck.maintenanceEvents.length }} Maintenance Events</mat-expansion-panel-header
                  >
                  <div
                    *ngFor="let event of truck.maintenanceEvents; trackBy: 'createdAt' | trackByKey"
                    class="flex flex-row justify-between items-center"
                  >
                    <span>{{ event.description }}</span>
                    <span>{{ event.createdAt | ago }}</span>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </ng-container>
            <div class="flex flex-row mt-1 justify-between">
              <button color="primary" mat-stroked-button (click)="openTruckMaintenanceEventModal(truck.truckId)">
                Report Maintenance
              </button>
              <button color="primary" mat-stroked-button (click)="editTruckPrompt(truck)">Edit Truck</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="trailers$ | async as trailers">
      <div class="flex flex-row justify-between">
        <div class="text-lg font-bold mb-1">Trailers</div>
        <button mat-stroked-button color="primary" (click)="addTrailerPrompt()">Add Trailer</button>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-1 mt-1" *ngIf="trailers.length; else noTrailers">
        <div *ngFor="let trailer of trailers; trackBy: 'id' | trackByKey">
          <div class="bg-white shadow rounded p-2 flex flex-col">
            <div class="font-semibold flex justify-between font-semibold">
              <span>{{ trailer.trailerName }}</span>
              <span [ngClass]="trailer.trailerStatus !== 'operational' ? 'text-red-500' : ''">{{
                trailer.trailerStatus | operational
              }}</span>
            </div>
            <ng-container *ngIf="trailer.inUse">
              Currently in used by {{ trailer.lastUsed.userName }} on load {{ trailer.lastUsed.uniqueOrderId }}
            </ng-container>
            <div class="mt-1 hidden md:contents">
              <img
                class="w-full"
                *ngIf="trailer.lastUsed"
                [src]="imageUrl(trailer.lastUsed.lastLocation[1], trailer.lastUsed.lastLocation[0])"
              />
            </div>
            <div class="mt-1 md:hidden">
              <img
                class="w-full"
                *ngIf="trailer.lastUsed"
                [src]="imageUrlMobile(trailer.lastUsed.lastLocation[1], trailer.lastUsed.lastLocation[0])"
              />
            </div>
            <div class="text-sm text-gray-500 mt-1">
              <ng-container *ngIf="trailer.trailerOwner">{{ trailer.trailerOwner }}</ng-container>
              <ng-container *ngIf="trailer.trailerOwner && trailer.trailerLessee"> - </ng-container>
              <ng-container *ngIf="trailer.trailerLessee">{{ trailer.trailerLessee }}</ng-container>
            </div>
            <ng-container *ngIf="trailer.maintenanceEvents.length">
              <mat-accordion displayMode="flat">
                <mat-expansion-panel class="rounded-none mat-elevation-z0">
                  <mat-expansion-panel-header style="padding: 0 !important"
                    >{{ trailer.maintenanceEvents.length }} Maintenance Events</mat-expansion-panel-header
                  >
                  <div
                    *ngFor="let event of trailer.maintenanceEvents; trackBy: 'createdAt' | trackByKey"
                    class="flex flex-row justify-between items-center"
                  >
                    <span>{{ event.description }}</span>
                    <span>{{ event.createdAt | ago }}</span>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </ng-container>
            <div class="flex flex-row mt-1 justify-between">
              <button color="primary" mat-stroked-button (click)="openTrailerMaintenanceEventModal(trailer.trailerId)">
                Report Maintenance
              </button>
              <button color="primary" mat-stroked-button (click)="editTrailerPrompt(trailer)">Edit Trailer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #truckMaint>
  <div mat-dialog-title>Record Truck Maintenance</div>
  <div mat-dialog-content>
    <form *ngIf="truckMainForm" [formGroup]="truckMainForm" class="w-full flex flex-col my-1">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>
      <mat-checkbox color="primary" formControlName="notOperational">Mark Truck as Not Operational</mat-checkbox>
    </form>
  </div>
  <div mat-dialog-actions class="flex flex-row justify-between">
    <button mat-stroked-button color="accent" mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="addTruckMaintenanceEvent()">Report</button>
  </div>
</ng-template>

<ng-template #trailerMaint>
  <div mat-dialog-title>Record Trailer Maintenance</div>
  <div mat-dialog-content>
    <form *ngIf="trailerMainForm" [formGroup]="trailerMainForm" class="w-full flex flex-col my-1">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>
      <mat-checkbox color="primary" formControlName="notOperational">Mark Trailer as Not Operational</mat-checkbox>
    </form>
  </div>
  <div mat-dialog-actions class="flex flex-row justify-between">
    <button mat-stroked-button color="accent" mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="addTrailerMaintenanceEvent()">Report</button>
  </div>
</ng-template>

<ng-template #addTruck>
  <div mat-dialog-title>Add Truck</div>
  <div mat-dialog-content>
    <ng-container *ngIf="addingAsset$$ | async; else addAssetForm">
      <div class="flex items-center justify-center">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-template #addAssetForm>
      <mat-form-field class="w-full">
        <mat-label>Truck Number</mat-label>
        <input matInput #truckName autocomplete="off" class="uppercase" />
      </mat-form-field>
      <div class="flex justify-between">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-stroked-button color="primary" (click)="addNewTruck(truckName.value)" [disabled]="!truckName.value">
          Add Truck
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #addTrailer>
  <div mat-dialog-title>Add Trailer</div>
  <div mat-dialog-content>
    <ng-container *ngIf="addingAsset$$ | async; else addAssetForm">
      <div class="flex items-center justify-center">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-template #addAssetForm>
      <mat-form-field class="w-full">
        <mat-label>Trailer Number</mat-label>
        <input matInput #trailerName autocomplete="off" class="uppercase" />
      </mat-form-field>
      <div class="flex justify-between">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-stroked-button (click)="addNewTrailer(trailerName.value)" [disabled]="!trailerName.value">
          Add Trailer
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #editTruck>
  <ng-container *ngIf="editTruckForm">
    <div mat-dialog-title>Editing Truck {{ editTruckForm.value.originalName }}</div>
    <div mat-dialog-content>
      <form [formGroup]="editTruckForm" class="w-full grid grid-cols-1 md:grid-cols-2 gap-2 my-2">
        <mat-form-field class="md:col-span-2">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Owner</mat-label>
          <input matInput formControlName="owner" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Lessee</mat-label>
          <input matInput formControlName="lessee" />
        </mat-form-field>
        <mat-checkbox color="primary" formControlName="operational">Truck Operational</mat-checkbox>
      </form>
    </div>
    <div mat-dialog-actions class="flex-row justify-between">
      <div>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="warn" (click)="archiveTruckPrompt()" *ngIf="!editTruckForm.value.inUse">
          Remove Truck
        </button>
      </div>
      <button mat-stroked-button color="primary" (click)="editTruckSave()" [disabled]="editTruckForm.invalid">
        Edit Truck
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #confirmTruckArchive>
  <ng-container *ngIf="editTruckForm">
    <div mat-dialog-title>Remove Truck {{ editTruckForm.value.originalName }}</div>
    <div mat-dialog-content>
      <div class="font-semibold text-red-500">
        This will remove truck {{ editTruckForm.value.originalName }} from your account forever. Are you sure you want
        to remove this truck?
      </div>
    </div>
    <div mat-dialog-actions class="flex-row justify-between">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button color="warn" (click)="archiveTruckSave()">Remove Truck</button>
    </div>
  </ng-container>
</ng-template>

<ng-template #editTrailer>
  <ng-container *ngIf="editTrailerForm">
    <div mat-dialog-title>Editing Trailer {{ editTrailerForm.value.originalName }}</div>
    <div mat-dialog-content>
      <form [formGroup]="editTrailerForm" class="w-full grid grid-cols-1 md:grid-cols-2 gap-2 my-2">
        <mat-form-field class="md:col-span-2">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Owner</mat-label>
          <input matInput formControlName="owner" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Lessee</mat-label>
          <input matInput formControlName="lessee" />
        </mat-form-field>
        <mat-checkbox color="primary" formControlName="operational">Trailer Operational</mat-checkbox>
      </form>
    </div>
    <div mat-dialog-actions class="flex-row justify-between">
      <div>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="warn" (click)="archiveTrailerPrompt()" *ngIf="!editTrailerForm.value.inUse">
          Remove Trailer
        </button>
      </div>
      <button mat-stroked-button color="primary" (click)="editTrailerSave()" [disabled]="editTrailerForm.invalid">
        Edit Trailer
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #confirmTrailerArchive>
  <ng-container *ngIf="editTrailerForm">
    <div mat-dialog-title>Remove Truck {{ editTrailerForm.value.originalName }}</div>
    <div mat-dialog-content>
      <div class="font-semibold text-red-500">
        This will remove trailer {{ editTrailerForm.value.originalName }} from your account forever. Are you sure you
        want to remove this truck?
      </div>
    </div>
    <div mat-dialog-actions class="flex-row justify-between">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button color="warn" (click)="archiveTrailerSave()">Remove Trailer</button>
    </div>
  </ng-container>
</ng-template>

<ng-template #noTrucks>
  <div class="w-full h-full justify-center">
    <span class="text-gray-600">You have no trucks yet.</span>
  </div>
</ng-template>

<ng-template #noTrailers>
  <div class="w-full h-full justify-center">
    <span class="text-gray-600">You have no trailers yet.</span>
  </div>
</ng-template>
